import { ProductDoc } from '@gooduncles/gu-app-schema';
import useSWRImmutable from 'swr/immutable';

import { getProduct } from 'src/utils/firebase/firebase-short-cut';

const useSWRProduct = (productId: ProductDoc['_id'] | null) => {
  const {
    data: product,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(productId ? `product-${productId}` : null, () => getProduct(productId as string));

  return {
    product,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRProduct;
